// LMS Route Constants
// Note: Only exports route path constants. LMS routes are now defined in admin-routes.js and superadmin-routes.js

export const LMS_ROUTE_BASE = '/nimblylearn';

const LMS_ROUTE_USERS = `${LMS_ROUTE_BASE}/users`;
const LMS_ROUTE_USER_GROUP = `${LMS_ROUTE_BASE}/user-groups`;
const LMS_ROUTE_CUSTOM_GROUP = `${LMS_ROUTE_BASE}/custom-groups`;

const LMS_ROUTE_COURSE = `${LMS_ROUTE_BASE}/course`;
const LMS_ROUTE_SYLLABUS = `${LMS_ROUTE_BASE}/syllabus`;
const LMS_ROUTE_COURSE_SYLLABUS = `${LMS_ROUTE_BASE}/courses-and-syllabus`;
const LMS_ROUTE_QUIZ = `${LMS_ROUTE_BASE}/quiz`;

export const LMS_ROUTE = {
	DASHBOARD: `${LMS_ROUTE_BASE}/dashboard`,

	USERS: LMS_ROUTE_USERS,
	USER_CREATE: `${LMS_ROUTE_USERS}/new`,
	USER_ADD: `${LMS_ROUTE_USERS}/add`,
	USER_EDIT: `${LMS_ROUTE_USERS}/edit`,
	USER_EDIT_BULK: `${LMS_ROUTE_USERS}/bulk-edit`,
	USER_BULK_UPLOAD: `${LMS_ROUTE_USERS}/bulk-upload`,

	USER_GROUPS: LMS_ROUTE_USER_GROUP,
	USER_GROUP_CREATE: `${LMS_ROUTE_USER_GROUP}/new`,
	USER_GROUP_EDIT: `${LMS_ROUTE_USER_GROUP}/edit`,

	CUSTOM_GROUPS: LMS_ROUTE_CUSTOM_GROUP,
	CUSTOM_GROUP_CREATE: `${LMS_ROUTE_CUSTOM_GROUP}/new`,
	CUSTOM_GROUP_EDIT: `${LMS_ROUTE_CUSTOM_GROUP}/edit`,

	COURSE_AND_SYLLABUS_MANAGEMENT: `${LMS_ROUTE_COURSE_SYLLABUS}/manage/:dataType`,
	COURSE_AND_SYLLABUS_MANAGEMENT_BASE: `${LMS_ROUTE_COURSE_SYLLABUS}/manage`,

	COURSE: `${LMS_ROUTE_COURSE}`,
	COURSE_CREATE: `${LMS_ROUTE_COURSE}/new`,
	COURSE_EDIT: `${LMS_ROUTE_COURSE}/edit`,
	COURSE_DETAILS: `${LMS_ROUTE_COURSE}/details`,

	SYLLABUS: `${LMS_ROUTE_SYLLABUS}`,
	SYLLABUS_CREATE: `${LMS_ROUTE_SYLLABUS}/new`,
	SYLLABUS_EDIT: `${LMS_ROUTE_SYLLABUS}/edit`,
	SYLLABUS_QUIZ: `${LMS_ROUTE_SYLLABUS}/:syllabusId/quiz/:quizId`,

	COURSE_AND_SYLLABUS_CATALOG: `${LMS_ROUTE_COURSE_SYLLABUS}`,
	COURSE_AND_SYLLABUS_SEARCH: `${LMS_ROUTE_COURSE_SYLLABUS}/search`,
	MY_COURSE_AND_SYLLABUS: `${LMS_ROUTE_COURSE_SYLLABUS}/me`,

	QUIZ_MANAGEMENT: `${LMS_ROUTE_QUIZ}/manage`,
	QUIZ_CREATE: `${LMS_ROUTE_QUIZ}/new`,
	QUIZ_CREATE_BULK: `${LMS_ROUTE_QUIZ}/bulk-create`,
	QUIZ_EDIT: `${LMS_ROUTE_QUIZ}/edit`,
	QUIZ_EDIT_BULK: `${LMS_ROUTE_QUIZ}/bulk-edit`,
};
